import {createRouter, createWebHistory, createMemoryHistory} from "vue-router";
import { h, resolveComponent } from "vue";
import i18n from "../i18n";
import { list, defaultLocale, lang } from "../translate";

const baseUrl = import.meta.env.BASE_URL
const history = import.meta.env.SSR ? createMemoryHistory(baseUrl) : createWebHistory(baseUrl)
const serverRunning = typeof window === 'undefined'



const routesSub = [
    {
        path: '/',
        component: () => import("../views/Main.vue"),
        meta: {
            title: 'titleMain',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionMain'
                }
            ]
        }
    },
    {
        path: '/trade/:pair?',
        component: () =>  import('../views/Trade.vue'),
        meta: {
            title: 'tradeLogin',
            metaTags: [
                {
                    name: 'description',
                    content: 'tradeLogin'
                }
            ]
        }
    },
    {
        path: '/login',
        component: () =>  import('../views/auth/Login.vue'),
        meta: {
            title: 'titleLogin',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLogin'
                }
            ]
        }
    },
    {
        path: '/user/confirm-email/:token',
        component: () =>  import('../views/auth/Login.vue'),
        meta: {
            title: 'titleConfirmEmail',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionConfirmEmail'
                }
            ]
        }
    },
    {
        path: '/auth/auto-login',
        component: () =>  import('../views/auth/AutoLogin.vue'),
        meta: {
            title: '',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionConfirmEmail'
                }
            ]
        }
    },
    {
        path: '/registration',
        component: () => import('../views/auth/SignUp.vue'),
        meta: {
            title: 'titleRegistration',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionRegistration'
                }
            ]
        }
    },
    {
        path: '/recovery-password',
        component: () => import('../views/auth/RecoveryPasswordRequest.vue'),
        meta: {
            title: 'titleRecoveryPassword',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionRecoveryPassword'
                }
            ]
        }
    },
    {
        path: '/recovery-password/:token',
        component: () => import('../views/auth/RecoveryPasswordConfirm.vue'),
        meta: {
            title: 'titleRecoveryPassword',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionRecoveryPassword'
                }
            ]
        }
    },
     {
         path: '/convert/:pair?',
         component: () => import('../views/Convert.vue'),
         meta: {
             title: 'titleConvert',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionConvert'
                 }
             ]
         }
     },
    {
        path: '/faq',
        component: () => import('../views/Help.vue'),
        meta: {
            title: 'titleFaq',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionFaq'
                }
            ]
        }
    },
   /* {
        path: '/help/lesson/:link',
        component: () => import('../views/Lesson.vue'),
        meta: {
            title: 'titleLesson',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLesson'
                }
            ]
        }
    },*/
    {
        path: '/page/about',
        component: () => import('../views/about/About.vue'),
        meta: {
            title: 'titleAbout',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionAbout'
                }
            ]
        },
    },
    {
        path: '/page/team',
        component: () => import('../views/about/Team.vue'),
        meta: {
            title: 'titleTeam',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionTeam'
                }
            ]
        },
    },
    {
        path: '/page/24-7-support',
        component: () => import('../views/Support.vue'),
        meta: {
            title: 'titleSupport',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionSupport'
                }
            ]
        },
    },
    {
        path: '/page/liquidity',
        component: () => import('../views/Liquide.vue'),
        meta: {
            title: 'titleLiquidity',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLiquidity'
                }
            ]
        },
    },
    {
        path: '/page/security',
        component: () => import('../views/Security.vue'),
        meta: {
            title: 'titleSecurity',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionSecurity'
                }
            ]
        },
    },
    {
        path: '/page/terms',
        component: () => import('../views/about/Terms.vue'),
        meta: {
            title: 'titleTerms',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionTerms'
                }
            ]
        }
    },
    {
        path: '/page/risk',
        component: () => import('../views/about/Risk.vue'),
        meta: {
            title: 'titlePrivacy',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionPrivacy'
                }
            ]
        }
    },
    {
        path: '/page/benefits',
        component: () => import('../views/about/Benefits.vue'),
        meta: {
            title: 'titlePageBenefits',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionPageBenefits'
                }
            ]
        }
    },
    {
        path: '/page/documents',
        component: () => import('../views/about/AboutTrade.vue'),
        meta: {
            title: 'titlePageTrade',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionPageTrade'
                }
            ]
        }
    },
    {
        path: '/page/contacts',
        component: () => import('../views/about/ServiceRegulation.vue'),
        meta: {
            title: 'titlePageRegulations',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionPageRegulations'
                }
            ]
        }
    },
    {
        path: '/tools/cryptocurrencies',
        component: () => import('../views/markets/Cryptocurrencies.vue'),
        meta: {
            title: 'titleToolsCryptocurrencies',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionToolsCryptocurrencies'
                }
            ]
        }
    },
    {
        path: '/tools/currencies',
        component: () => import('../views/markets/Currencies.vue'),
        meta: {
            title: 'titleToolsCurrencies',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionToolsCurrencies'
                }
            ]
        }
    },
    {
        path: '/oauth2/login',
        component: () => import('../views/oauth2/Login.vue'),
        meta: {
            title: 'titleLogin',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLogin'
                }
            ]
        }
    },
    {
        path: '/tools/energy',
        component: () => import('../views/markets/Energy.vue'),
        meta: {
            title: 'titleToolsEnergy',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionToolsEnergy'
                }
            ]
        }
    },
    {
        path: '/tools/shares',
        component: () => import('../views/markets/Shares.vue'),
        meta: {
            title: 'titleToolsShares',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionToolsShares'
                }
            ]
        }
    },
     {
         path: '/site/fees',
         component: () => import('../views/Commission.vue'),
         meta: {
             title: 'titleFees',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionFees'
                 }
             ]
         }
     },
     {
         path: '/page/api',
         component: () => import('../views/about/PageApi.vue'),
         meta: {
             title: 'titleApi',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionApi'
                 }
             ]
         }
     },
     {
         path: '/page/auth',
         component: () => import('../views/about/PageAuth.vue'),
         meta: {
             title: 'titleApiAuth',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionApi'
                 }
             ]
         }
     },
     {
         path: '/page/account',
         component: () => import('../views/about/PageAccount.vue'),
         meta: {
             title: 'titleApiAccount',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionApi'
                 }
             ]
         }
     },
     {
         path: '/page/news',
         component: () => import('../views/about/PageFAQ.vue'),
         meta: {
             title: 'titleApiNews',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionApi'
                 }
             ]
         }
     },
     {
         path: '/page/introduction',
         component: () => import('../views/about/PageIntroduction.vue'),
         meta: {
             title: 'titleApiIntroduction',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionApi'
                 }
             ]
         }
     },

     {
         path: '/page/bills',
         component: () => import('../views/about/AboutBills.vue'),
         meta: {
             title: 'titlePageBills',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionPageBills'
                 }
             ]
         }
     },
     {
         path: '/page/exchange',
         component: () => import('../views/about/AboutExchange.vue'),
         meta: {
             title: 'titlePageExchange',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionPageExchange'
                 }
             ]
         }
     },
     {
         path: '/page/verification',
         component: () => import('../views/about/AboutVerification.vue'),
         meta: {
             title: 'titlePageVerification',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionPageVerification'
                 }
             ]
         }
     },

     {
         path: '/site/deposit-withdrawal',
         component: () => import('../views/about/Deposit.vue'),
         meta: {
             title: 'titlePageDeposit',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionPageDeposit'
                 }
             ]
         }
     },
    {
        path: '/site/system-status',
        component: () => import('../views/about/StateSystem.vue'),
        meta: {
            title: 'titlePageSystemState',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionPageSystemState'
                }
            ]
        }
    },
     {
         path: '/page/partner',
         component: () => import('../views/about/Affiliate.vue'),
         meta: {
             title: 'titlePagePartner',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionPagePartner'
                 }
             ]
         }
     },
     {
         path: '/page/user-support',
         component: () => import('../views/about/UserSupport.vue'),
         meta: {
             title: 'titlePageUserSupport',
             metaTags: [
                 {
                     name: 'description',
                     content: 'descriptionPageUserSupport'
                 }
             ]
         }
     },
    {
        path: '/asset/:asset',
        component: () => import('../views/Asset.vue'),
        meta: {
            title: 'titleAsset',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionAsset'
                }
            ]
        }
    },
    {
        path: '/all-markets',
        component: () => import('../views/Markets.vue'),
        meta: {
            title: 'titleMarkets',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionMarkets'
                }
            ]
        }
    },
    {
        path: '/learn/what-is-cryptocurrency',
        component: () => import('../views/education/CryptoEduc.vue'),
        meta: {
            title: 'titleLearnCrypto',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLearnCrypto'
                }
            ]
        }
    },
    {
        path: '/learn/types-of-cryptocurrency',
        component: () => import('../views/education/TypeCrypto.vue'),
        meta: {
            title: 'titleLearnTypeCrypto',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLearnTypeCrypto'
                }
            ]
        }
    },
    {
        path: '/learn/what-is-blockchain',
        component: () => import('../views/education/BlockChainEduc.vue'),
        meta: {
            title: 'titleLearnBlockchain',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLearnBlockchain'
                }
            ]
        }
    },
    {
        path: '/learn/what-is-btc',
        component: () => import('../views/education/BitcoinEduc.vue'),
        meta: {
            title: 'titleLearnBTC',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLearnBTC'
                }
            ]
        }
    },
    {
        path: '/learn/what-is-eth',
        component: () => import('../views/education/EthereumEduc.vue'),
        meta: {
            title: 'titleLearnETH',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLearnETH'
                }
            ]
        }
    },
    {
        path: '/learn/what-is-nft',
        component: () => import('../views/education/NFTEduc.vue'),
        meta: {
            title: 'titleLearnNFT',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLearnNFT'
                }
            ]
        }
    },
    {
        path: '/learn/what-is-dao',
        component: () => import('../views/education/DaoEduc.vue'),
        meta: {
            title: 'titleLearnDAO',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionLearnDAO'
                }
            ]
        }
    },
    {
        path: '/events/new-listing-promos',
        component: () => import('../views/listings.vue'),
        meta: {
            title: 'titleListingShares',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionListingShares'
                }
            ]
        }
    },
    {
        path: '/events/ipo-calendar',
        component: () => import('../views/ipoCalendar.vue'),
        meta: {
            title: 'IPO Calendar',
            metaTags: [
                {
                    name: 'description',
                    content: 'IPO Calendar'
                }
            ]
        }
    },
    {
        path: '/events/ai-trading-bot',
        component: () => import('../views/aiTradingBot.vue'),
        meta: {
            title: 'titleAiTradingBot',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionAiTradingBot'
                }
            ]
        }
    },
    {
        path: '/events/trading-bot-info',
        component: () => import('../views/tradingBitInfo.vue'),
        meta: {
            title: 'titleTradingBotInfo',
            metaTags: [
                {
                    name: 'description',
                    content: 'descriptionTradingBotInfo'
                }
            ]
        }
    },
     {
         path: '/options',
         component: () => import('../views/options/index.vue')
     }
]

let routes = []

routesSub.forEach(e => {
    list.forEach(lang => {
        if(defaultLocale ==  lang.id) {
            routes.push({
                path: e.path,
                component: e.component,
                meta: e.meta
            })
        } else {

            routes.push({
                path: "/" + lang.id + (e.path === "/" ? "" : e.path),
                component: e.component,
                meta: e.meta,
                beforeEnter(to, from, next) {
                    i18n.global.locale.value = lang.id
                    return next()
                }
            })
        }
    })
})
routes.push({
    path: '/:pathMatch(.*)*',
    component: () => import('../components/layout/404.vue')
})

const index = createRouter({
    history,
    routes,
    scrollBehavior() {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    }
})

if(!serverRunning) {
    index.beforeEach((to, from, next) => {

        const decode = decodeUrl(to.path)

        const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
        const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)
        const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)


        if (nearestWithTitle) {
            const titleLoc = lang[decode.lang].header[nearestWithTitle.meta.title]
            if(titleLoc !== undefined) {
                document.title = titleLoc.replace('{brandName}' , import.meta.env.VITE_APP_BRAND_NAME)
            }

        } else if (previousNearestWithMeta) {
            document.title = previousNearestWithMeta.meta.title
        }

        Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

        if (!nearestWithMeta) return next()

        nearestWithMeta.meta.metaTags.map(tagDef => {
            const tag = document.createElement('meta')

            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, tagDef[key])
            })

            tag.setAttribute('data-vue-router-controlled', '')

            return tag;
        }).forEach(tag => document.head.appendChild(tag))
        next()
    })
}

function decodeUrl(url) {
    const urlParts = url.split('/');
    const firstPart = urlParts[1];
    if (list.find(e => e.id === firstPart)) {
        const lang = firstPart;
        const  path = '/' + urlParts.slice(2).join('/');
        return { lang, path};
    }

    return { lang: defaultLocale, path: url };
}
export default index